import BreadCrumb from "Components/Common/BreadCrumb";
import { Card, Col, Container, Row } from "reactstrap";
import Select from "react-select";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { debounce } from "lodash";

import { getCategoryProductPerformanceThunk, getSellerPerformanceThunk } from "live-slices/SellerPerformance/thunk";
import {
  getBrandCopyThunk,
  getBrandThunk,
  getCategoryThunk,
} from "live-slices/thunk";

import calendar from "../../assets/images/calendarOutline.png";
import downloadIcon from "../../assets/images/Frame 1272628235.png";
import sortIcon from "../../assets/images/sort.png";
import searchIcon from "../../assets/images/searchNormal.png";
import infoIcon from "../../assets/images/Info-icon.png"; // This was imported but not used in the final JSX
import copyIcon from "../../assets/images/copy.png";
import BuypassFavicon from "../../assets/images/buyPass-favicon.png";
import warning from "../../assets/images/warningIcon.svg";

import "./ProductPerfomance.scss";
import ErrorModal from "Components/Common/ErrorModal";
import DatePicker from "react-datepicker";
import { number } from "yup";

const ProductPerformance = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const dispatch: any = useDispatch();
  const [allSellerPerformanced, setAllSellerPerformance] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>("");
  const [selectedBrand, setSelectedBrand] = useState<any>("");
  const [searchQuery, setSearchQuery] = useState("");
  const [keywordType, setKeywordType] = useState("");
  const [sortProduct, setSortProduct] = useState(1);
  const [sortCart, setSortCart] = useState(1);
  const [sortSold, setSortSold] = useState(1);
  const [isProductVisitorFilter, setIsProductVisitorFilter] = useState<boolean>(false);
  const [isProductVisitorFilterCr, setIsProductVisitorFilterCr] = useState<boolean>(false);
  const [addToCartUnitsFilter, setAddToCartUnitsFilter] = useState<boolean>(false);
  const [addToCartUnitsFilterCr, setAddToCartUnitsFilterCr] = useState<boolean>(false);
  const [unitsSoldFilter, setUnitsSoldFilter] = useState<boolean>(false);
  const [unitsSoldFilterCr, setUnitsSoldFilterCr] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [categoryOption, setCategoryOption] = useState<
    Array<{ label: string; value: any }>
  >([]);
  const [brandOption, setBrandOption] = useState<
    Array<{ label: string; value: any }>
  >([]);
  const itemsPerPage = 10;
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const formatDate = (date: Date | null) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, "0");
    const d = date.getDate().toString().padStart(2, "0");
    return `${m}/${d}/${y}` || "-- -- ----";
  };


          useEffect(() => {
  if (!searchQuery) return;
  const debounceTyping = setTimeout(() => {
    fetchSellerPerformance();
  }, 500);

  return () => clearTimeout(debounceTyping);
}, [searchQuery,currentPage]);

  useEffect(() => {
    fetchSellerPerformance();
    if (selectedCategory) {
      fetchSellerPerformance(currentPage, selectedCategory);
    }
    if (selectedBrand) {
      fetchSellerPerformance(currentPage, selectedBrand);
    }
  }, [
    currentPage,
    itemsPerPage,
    selectedCategory,
    selectedBrand,
    startDate,
    endDate,
    sortProduct,
    sortCart,
    sortSold,
    isProductVisitorFilter,
    isProductVisitorFilterCr,
    addToCartUnitsFilter,
    addToCartUnitsFilterCr,
    unitsSoldFilter,
    unitsSoldFilterCr
  ]);

  const isAnyFilterActive =
  isProductVisitorFilter ||
  isProductVisitorFilterCr ||
  addToCartUnitsFilter ||
  addToCartUnitsFilterCr ||
  unitsSoldFilter ||
  unitsSoldFilterCr;

    const checkboxStates = [
    isProductVisitorFilter,
    isProductVisitorFilterCr,
    addToCartUnitsFilter,
    addToCartUnitsFilterCr,
    unitsSoldFilter,
    unitsSoldFilterCr
  ];
  const selectedCount = checkboxStates.filter(Boolean).length;
  const totalCheckboxes = checkboxStates.length;

  const selectAllSealData = createSelector(
    (state: any) => state.SellerPerformance,
    (sellerPerformance) => sellerPerformance?.getSellerPerformance
  );
  const allSellerPerformance = useSelector(selectAllSealData);



  const fetchSellerPerformance = async (
    page = currentPage,
    category = selectedCategory,
    brand = selectedBrand
  ) => {
    const resp = await dispatch(
      getSellerPerformanceThunk({
        startDate: formatDate(startDate) || "",
        endDate: formatDate(endDate) || "",
        keywordType: keywordType,
        page,
        count: itemsPerPage,
        keyword: searchQuery,
        brandId: brand?._id || "",
        categoryId: category?._id || "",
        sortTypeProduct: sortProduct,
        sortTypeCart: sortCart,
        sortTypeSold: sortSold,
        isProductVisitorFilter:isProductVisitorFilter,
        isProductVisitorFilterCr:isProductVisitorFilterCr,
        addToCartUnitsFilter:addToCartUnitsFilter,
        addToCartUnitsFilterCr:addToCartUnitsFilterCr,
        unitsSoldFilter:unitsSoldFilter,
        unitsSoldFilterCr:unitsSoldFilterCr
      })
    );
    if (resp.payload && resp.payload.data) {
      setAllSellerPerformance(resp.payload.data);
      setKeywordType('')
      setTotalPages(resp?.payload?.totalCount);
    } else {
      setAllSellerPerformance([]);
    }
  };

    const handleReset =()=>{
      setIsProductVisitorFilter(false);
      setIsProductVisitorFilterCr(false);
      setAddToCartUnitsFilter(false);
      setAddToCartUnitsFilterCr(false);
      setUnitsSoldFilter(false);
      setUnitsSoldFilterCr(false)
  }

  const handleCategorySearch = debounce(
    async (inputValue: string, type: string) => {
      if (!type) {
        setCategoryOption([]);
        setBrandOption([]);
        return;
      }
      let res: any;
      if (type === "category") {
        res = await dispatch(
          getCategoryProductPerformanceThunk(
            { page: 1, count: 10, keyword: inputValue }
          )
        );
        if (res?.payload) {
          setCategoryOption(
            res.payload.map((c: any) => ({
              label: c.name,
              value: c,
            }))
          );
        }
      }
      if (type === "brand") {
        res = await dispatch(
          getBrandCopyThunk({
            keyword: inputValue,
            page: 1,
            count: 10,
          })
        );
        if (res?.payload?.brands) {
          setBrandOption(
            res.payload.brands.map((c: any) => ({
              label: c.name,
              value: c,
            }))
          );
        }
      }
    },
    300
  );

  const handleSearch = (query: any) => {
    setSearchQuery(query);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showDatePicker, setShowDatePicker] = useState(false);


  const downloadPerformanceCSV = () => {
    const headers = [
      "Product Name",
      "Variant",
      "Seller SKU",
      "Visitors Count",
      "Visitors %",
      "Add to Cart Units",
      "Add to Cart %",
      "Units Sold",
      "Units Sold %",
    ];

    const rows = allSellerPerformance.map((item: any) => {
      const variantType = item?.variants?.[0]?.type || "-";
      const variantValues = item?.variants?.[0]?.values
        ?.map((v: any) => v?.name)
        .join(", ") || "-";

      return [
        item?.nameEn || "N/A",
        `${variantType}: ${variantValues}`,
        item?.subProduct?.sku || "--",
        item?.visitorsCount || "0",
        item?.visitorsCr || "0%",
        item?.addToCartUnist || "0",
        item?.cartCr || "0%",
        item?.unitsSold || "0",
        item?.unitsSoldCr || "0%",
      ];
    });

    const csvContent = [
      headers.join(","),
      ...rows.map((row: any) => row.map((value: any) => `"${value}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "seller_performance.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  return (
    <>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <div className="page-content page-content-mobile mobileTabDv">
        <Container fluid className="mobileTabDv">
          <BreadCrumb
            title="Product Performance"
            pageTitle="Business Advisor"
            pageTitleRoute="/key-metrics"
          />


          <Card className="campaign-info-card_1 mobileClenderCrad">
            <div className="d-flex justify-content-center align-items-center">
              <div className="campaign-header">
                <div style={{ position: "relative" }}>
                  <img
                    src={calendar}
                    alt="calendar"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowDatePicker((prev) => !prev)}
                  />
                  {showDatePicker && (
                    <div
                      style={{
                        position: "absolute",
                        top: "30px",
                        left: "0",
                        zIndex: 1000,
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
                      }}
                    >
                      <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(dates) => {
                          const [start, end] = dates as [Date | null, Date | null];
                          setStartDate(start);
                          setEndDate(end);
                        }}
                        inline
                      />
                    </div>
                  )}
                </div>
              </div>
              <h6 className="m-0 ms-2"> ({formatDate(startDate)} - {formatDate(endDate)})</h6>
            </div>
          </Card>

          <Card className="filters-card">
            <div className="filter-header">
              <Row className="mobileRow">
                <Col lg="5">
                  <div className="filter-options-heading">
                    <h3>Performance</h3>
                  </div>
                </Col>
                <Col lg="2">
                  <div>
                    <div className="filter-options">
                      <div className="filter-opyions-select">
                        <Select
                          id=""
                          isClearable
                          placeholder="Category"
                          options={categoryOption}
                          className=""
                          onInputChange={(inputValue: any) => {
                            if (inputValue) {
                              handleCategorySearch(inputValue, "category");
                            } else {
                              setCategoryOption([]);
                            }
                          }}
                          onMenuOpen={() => handleCategorySearch("", "category")}
                          onChange={(selected: any) => {
                            setSelectedCategory(selected?.value || null);
                            fetchSellerPerformance(1, selected?.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="2">
                  <div className="filter-options">
                    <div className="filter-opyions-select">
                      <Select
                        id="brandSelect"
                        isClearable
                        placeholder="Brand"
                        options={brandOption}
                        className="Input-width"
                        onInputChange={(inputValue: any) => {
                          if (inputValue) {
                            handleCategorySearch(inputValue, "brand");
                          } else {
                            setBrandOption([]);
                          }
                        }}
                        onMenuOpen={() => handleCategorySearch("", "brand")}
                        onChange={(selected: any) => {
                          setSelectedBrand(selected?.value || null);
                          fetchSellerPerformance(1, selected?.value);
                        }}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg="2">
                  <div className="filter-options">
                    <div className="filter-opyions-select">
                      <div className="search-wrapper">
                        <input
                          type="text"
                          placeholder="Seller SKU or Name"
                          className="search-input-with-icon"
                          data-testing-id="search_productPerformance"
                          value={searchQuery}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                        <img
                          src={searchIcon}
                          alt="Search Icon"
                          className="search-icon-inside"
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="1">
                  <div className="download-section" onClick={() => downloadPerformanceCSV()}>
                    <h5>Download</h5>
                    <span>
                      <img src={downloadIcon} alt="Download Icon" />
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="checkBoxData mobile-hide">
              <Row >
                <Col className="col" lg='9' md='9' >
                  <Row className="CheckBoxRow">
                    <Col className="col" lg='2' md='2' ><p>Traffic</p></Col>
                    <Col className="col" lg='3' md='3'>
                      <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input"  checked={isProductVisitorFilter} onChange={(e) => setIsProductVisitorFilter(e.target.checked)}/>
                        <p>Product Visitors</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Product Pageview</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='4' md='4'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Visitor Value</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='2' md='2'></Col>
                     <Col className="col" lg='4' md='4'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input"  checked={isProductVisitorFilterCr} onChange={(e) => setIsProductVisitorFilterCr(e.target.checked)} />
                        <p>Product Visitors conversion rates</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                  </Row>
                  <Row className="CheckBoxRow mt-3">
                    <Col className="col" lg='2' md='2' ><p>Add to Cart</p></Col>
                    <Col className="col" lg='3' md='3'>
                      <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Add to cart users</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" checked={addToCartUnitsFilter} onChange={(e) => setAddToCartUnitsFilter(e.target.checked)}/>
                        <p>Add to cart units</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='4' md='4'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input"  checked={addToCartUnitsFilterCr} onChange={(e) => setAddToCartUnitsFilterCr(e.target.checked)}/>
                        <p>Add to cart conversion rates</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='2' md='2'></Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Wishlist</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                  </Row>
                  <Row className="CheckBoxRow mt-3">
                    <Col className="col" lg='2' md='2' ><p>Conversion</p></Col>
                    <Col className="col" lg='3' md='3'>
                      <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Buyers</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Others</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='4' md='4'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" checked={unitsSoldFilter} onChange={(e) => setUnitsSoldFilter(e.target.checked)}/>
                        <p>Units Sold</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='2' md='2'></Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Revenue</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" checked={unitsSoldFilterCr} onChange={(e) => setUnitsSoldFilterCr(e.target.checked)}/>
                        <p>Conversion Rates</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='4' md='4'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Revenue per Buyer</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    <Col className="col" lg='2' md='2'></Col>
                    <Col className="col" lg='3' md='3'>
                     <div className=" d-flex justify-content-start align-items-center gap-2">
                        <input type="checkbox" className="sellerCheckbox m-0 form-check-input" />
                        <p>Revenue Share</p>
                        <img src={warning} alt=""  className="iIcon"/>
                      </div>
                    </Col>
                    
                  </Row>
                </Col>
                <Col className="col" lg='3' md='3' >
                  <div className=" d-flex justify-content-end align-items-center g-2">
                    <p>Selected: {selectedCount}/{totalCheckboxes}</p>
                    <button type="button" className="btn resetButton btn-outline-secondary" onClick={()=> handleReset()}>Reset</button>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="metrics-card">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="first-Child">
                        <div className="Performance">
                          <div className="information">
                            <h6>Performance Information</h6>
                          </div>
                          <img src={sortIcon} alt="Sort" />
                        </div>
                      </th>
                      <th>
                        <div className="Performance">
                          <div className="information">
                            <h6>Product Visitors</h6>
                          </div>
                          <img src={sortIcon} alt="Sort" onClick={() => setSortProduct(prev => (prev === 1 ? -1 : 1))}
                            style={{
                              transform: sortProduct === -1 ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.3s ease",
                            }} />
                        </div>
                      </th>
                      <th>
                        <div className="Performance">
                          <div className="information">
                            <h6>Add to cart units</h6>
                          </div>
                          <img src={sortIcon} alt="Sort" onClick={() => setSortCart(prev => (prev === 1 ? -1 : 1))}
                            style={{
                              transform: sortCart === -1 ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.3s ease",
                            }} />
                        </div>
                      </th>
                      <th>
                        <div className="Performance">
                          <div className="Unit">
                            <h6>Units Sold</h6>
                            <img
                              src={sortIcon} alt="Sort"
                              onClick={() => setSortSold(prev => (prev === 1 ? -1 : 1))}
                              style={{
                                transform: sortSold === -1 ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.3s ease",
                              }} />
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                 <tbody>
  {isAnyFilterActive && Array.isArray(allSellerPerformance) && allSellerPerformance.length > 0 ? (
    allSellerPerformance.map((item: any, index: number) => (
      <tr key={item?.id || index}>
        <td>
          <div className="productInfo">
            <img
              src={item?.productImages?.[0]?.url || BuypassFavicon}
              alt="Product"
              className="productImg"
            />
            <div className="productDetails">
              <h5>{item?.nameEn || "N/A"}</h5>
              {item?.variants?.[0] && (
                <h6>
                  {item.variants[0].type}:{" "}
                  {item.variants[0].values?.length > 0
                    ? item.variants[0].values.map((value: any) => value?.name || "-").join(", ")
                    : "-"}
                </h6>
              )}
              <h6>
                Seller SKU: {item?.subProduct?.sku || "--"}
                <span
                  className="ms-1 cursor-pointer"
                  onClick={(event) => {
                    event.stopPropagation();
                    setKeywordType("sku");
                    navigator.clipboard.writeText(item?.subProduct?.sku);
                    setShowModal({ isVisible: true, color: true });
                    setErrorMessage("SKU Number Copied!.");
                    setTimeout(() => {
                      setShowModal({ isVisible: false, color: true });
                    }, 1000);
                  }}
                >
                  <img src={copyIcon} alt="" />
                </span>
              </h6>
            </div>
          </div>
        </td>

        <td>
          <div className="metric">
            <span className="number">{item?.visitorsCount || "0"}</span>
            <span className="percent">{item?.visitorsCr || "0"}% ↑</span>
          </div>
        </td>

        <td>
          <div className="metric">
            <span className="number">{item?.addToCartUnist || "0"}</span>
            <span className="percent">{item?.cartCr || "0"}% ↑</span>
          </div>
        </td>

        <td className="first-Child">
          <div className="metric">
            <span className="number">{item?.unitsSold || "0"}</span>
            <span className="percent">{item?.unitsSoldCr || "0"}% ↑</span>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center" }}>
        {isAnyFilterActive
          ? "No data available"
          : "Please select at least one filter to view data"}
      </td>
    </tr>
  )}
</tbody>

                </table>
              </div>
            </div>
            <div className="col-sm-auto mt-2 mobile-show">
<ul className="pagination pagination-separated pagination-rounded pagination-md justify-content-center justify-content-sm-start align-items-center mb-0">
  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
    <button className="page-link" onClick={handlePrevPage}>
      <i className="bx bx-left-arrow-alt fs-2" style={{ color: "#A2B1C3" }}></i>
    </button>
  </li>

  {isAnyFilterActive && Array.isArray(allSellerPerformance) && allSellerPerformance.length > 0 && (
    <>
      {currentPage > 3 && (
        <li className="page-item">
          <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
        </li>
      )}

      {currentPage > 4 && (
        <li className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      )}

      {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
        const startPage = Math.max(
          Math.min(currentPage - 2, totalPages - 4),
          1
        );
        const page = startPage + i;
        return (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button className="page-link" onClick={() => handlePageChange(page)}>
              {page}
            </button>
          </li>
        );
      })}

      {currentPage < totalPages - 3 && (
        <li className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      )}

      {currentPage < totalPages - 2 && (
        <li className="page-item">
          <button className="page-link" onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </button>
        </li>
      )}
    </>
  )}

  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
    <button className="page-link" onClick={handleNextPage}>
      <i className="bx bx-right-arrow-alt fs-2 cursor-pointer" style={{ color: "#A2B1C3" }}></i>
    </button>
  </li>
</ul>

</div>

            <div>
<div className="paginationDv mb-3 me-3 d-flex justify-content-end mobile-hide">
  <nav
    aria-label="Page navigation example"
    style={{
      background: "white",
      padding: "5px 5px",
      borderRadius: "4px",
      border: "1px solid #0877FF",
      display: "flex",
      alignItems: "center",
    }}
  >
   <h1
  style={{
    color: "#111417",
    margin: "0px 15px 0px 10px",
    fontSize: "14px",
    fontWeight: "500",
  }}
>
  Total {isAnyFilterActive && Array.isArray(allSellerPerformance) && allSellerPerformance.length > 0 ? totalPages : 0}
</h1>


  <ul
  className="pagination detailPagepagi m-0"
  style={{ display: "flex", gap: "10px" }}
>
  {isAnyFilterActive && Array.isArray(allSellerPerformance) && allSellerPerformance.length > 0 && (
    <>
      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
        <button
          style={{
            height: "26px",
            display: "flex",
            alignItems: "center",
            border: "none",
            marginRight: "0px",
          }}
          className="page-link"
          onClick={handlePrevPage}
        >
          <i className="bx bxs-left-arrow" style={{ height: "11px" }}></i>
        </button>
      </li>

      {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
        const startPage = Math.max(Math.min(currentPage - 2, totalPages - 4), 1);
        const page = startPage + i;
        if (page > totalPages) return null;
        return (
          <li
            style={{ borderRadius: "10px" }}
            className={`page-item ${currentPage === page ? "active" : ""}`}
            key={page}
          >
            <button
              style={{ height: "26px", margin: "0px" }}
              className="page-link orderPg"
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          </li>
        );
      })}

      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
        <button
          className="page-link orderPg"
          style={{
            height: "26px",
            display: "flex",
            alignItems: "center",
            border: "none",
            marginLeft: "0px",
          }}
          onClick={handleNextPage}
        >
          <i className="bx bxs-right-arrow" style={{ width: "6px", height: "11px" }}></i>
        </button>
      </li>
    </>
  )}
</ul>

  </nav>
</div>


            </div>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default ProductPerformance;
